// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private-landing-container {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  max-height: 50vh;
  padding-bottom: 0 !important;
}
.private-landing-container form {
  padding-bottom: 0px !important;
}

.form-group-button.private {
  background-color: #F4F7F8 !important;
}

.phone-code-number-container {
  margin-top: 0.2em;
  margin-bottom: 0;
}

.tel-code {
  background: whitesmoke;
  height: 100% !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
